const pageViewDataPush = (user) => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    digitalData.push({
      event: {
        name: "pageview",
      },
      user: {
        userType: "",
        aaId: user?.peep_analyticsid, //customerAccountUserID|peep_analyticsID
        ssoId: user?.ssoId, //SSOID|sub
        cas: user?.casId, //sourceaccount_Id
        authenticated: "is-logged-in",
      },
    });
  }
};

export default pageViewDataPush;
